// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInTooltip {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
#vue-app {
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 100%;
}

.search {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}
@media (min-width: 1920px) {
  .search {
    position: relative;
  }
}
.search.active {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
  transition: all 0.35s ease;
  background: #ffffff;
  border-bottom: 1px solid #e2e3f4;
}
.search.active .search-input-container {
  display: flex;
  align-items: center;
  gap: 5px;
}
.search.active .search-button {
  display: none;
}
.search.active .clear-button {
  display: flex;
}
.search .clear-button,
.search .search-button {
  width: 42px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search .clear-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: auto;
  right: 16px;
}
.search .clear-button .clear-path {
  stroke: #1b1b2d;
}
.search .clear-button.active {
  display: flex;
}
.search .search-button {
  margin-left: auto;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e2e3f4;
}
@media (min-width: 1024px) {
  .search .search-button {
    display: none;
  }
}
.search-input-container {
  width: 100%;
  position: relative;
  display: none;
  padding: 0 16px;
}
.search-input-container .close-button {
  display: flex;
}
@media (min-width: 1024px) {
  .search-input-container .close-button {
    display: none;
  }
}
@media (min-width: 1024px) {
  .search-input-container {
    display: block;
    padding: 0;
  }
}
.search-input {
  height: 100%;
  padding-left: 44px;
}
.search-input-icon {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
@media (min-width: 1024px) {
  .search-input-icon {
    left: 18px;
  }
}
.search-dropdown {
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  overflow: hidden;
  border: 1px solid #e2e3f4;
  border-radius: 8px;
  box-sizing: border-box;
  z-index: 12;
}
.search-dropdown.active {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 91px;
  border: none;
  right: 0;
  left: 0;
  height: calc(100vh - 168px);
  overflow-y: auto;
  border-radius: 0;
}
@media (min-width: 1024px) {
  .search-dropdown.active {
    top: 50px;
    overflow: hidden;
    height: auto;
    border-radius: 8px;
  }
}
@media (min-width: 1024px) {
  .search-mobile-menu {
    display: none;
  }
}
.search-mobile-menu-top {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e3f4;
}
.search-mobile-menu .search-mobile-filter {
  padding: 24px 16px;
  display: none;
}
.search-mobile-menu .search-mobile-filter-button {
  border: 1px solid #e2e3f4;
}
.search-mobile-menu .search-mobile-filter-button:hover, .search-mobile-menu .search-mobile-filter-button:focus, .search-mobile-menu .search-mobile-filter-button:active {
  border-color: #4667ff;
}
.search-mobile-menu .search-mobile-filter.active {
  display: block;
}
.search-mobile-menu .search-mobile-filter .filter-content-title {
  border-bottom: none;
}
.search-mobile-menu .search-mobile-buttons {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #e2e3f4;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  background: #ffffff;
}
.search-mobile-menu .search-mobile-buttons .search-mobile-button {
  flex: 1;
  padding: 12px;
  border: 1px solid #e2e3f4;
  border-radius: 8px;
}
.search-mobile-menu .search-mobile-buttons .search-mobile-button:hover, .search-mobile-menu .search-mobile-buttons .search-mobile-button:focus {
  border-color: #4667ff;
}
.search-dropdown-content {
  display: flex;
  align-items: stretch;
  flex: 1;
}
.search-dropdown-content.closed {
  display: none;
}
.search .filter {
  display: none;
  flex-basis: 460px;
  padding: 16px;
  flex-direction: column;
  gap: 24px;
}
@media (min-width: 1024px) {
  .search .filter {
    display: flex;
    border-right: 1px solid #e2e3f4;
  }
}
.search .filter-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.search .filter-header .button-toggle {
  margin-left: auto;
  border: 1px solid #e2e3f4;
  transition: all 0.35s ease;
}
.search .filter-header .button-toggle:hover {
  background: rgba(70, 103, 255, 0.12);
  border: 1px solid #4667ff;
}
.search .filter-header .button-filter {
  cursor: text;
}
.search .filter-content {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(90vh - 180px);
  padding-right: 20px;
}
.search .filter-content-title {
  display: block;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e3f4;
}
.search .filter-content-title-tags {
  margin-bottom: 16px;
}
.search .filter-content .filter-list-desktop .filter-list-item {
  display: none;
}
.search .filter-content .filter-list-desktop .filter-list-item:nth-child(-n+4) {
  display: flex;
}
.search .filter-content .button-nav-wrapper {
  padding-top: 16px;
}
.search .filter-content .button-nav {
  gap: 12px;
  font-weight: 500;
}
.search .filter-content .button-nav-icon {
  transition: all 0.35s ease;
  transform: rotate(180deg);
}
.search .filter-content .button-nav-hide {
  display: none;
}
.search .filter-content .select-button {
  padding: 8px 16px;
  border: 1px solid #e2e3f4;
}
.search .filter-content .select-options {
  width: auto;
  min-width: 100%;
}
.search .filter-content .select-options .select-option {
  padding: 8px 16px;
}
.search .filter-content .tags-select .select-options {
  top: 46px;
}
.search .filter-content .tags-select .select-options.active {
  opacity: 1;
  visibility: visible;
}
.search .filter-content .tags-select .select-option:first-child:focus, .search .filter-content .tags-select .select-option:first-child:hover {
  background-color: inherit;
}
.search .filter-content .tags-select .count {
  margin-left: 10px;
  color: #4667ff;
  font-weight: 500;
}
.search .filter-content .tags-select .select-option-search {
  position: relative;
}
.search .filter-content .tags-select .select-option-search .search-input-icon {
  left: 32px;
}
.search .filter-content .tags-select.opened .select-options {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.search .filter-content.opened .filter-list-item {
  display: flex;
}
.search .filter-content.opened .button-nav-more {
  display: none;
}
.search .filter-content.opened .button-nav-hide {
  display: flex;
}
.search .filter-content.opened .button-nav-icon {
  transform: rotate(0deg);
}
.search .filter.toggleable-content {
  display: none;
  flex-direction: column;
  gap: 24px;
  transition: all 0.35s ease;
}
@media (min-width: 1024px) {
  .search .filter.toggleable-content {
    display: flex;
  }
}
.search .filter.toggleable-content.closed {
  flex-basis: 108px;
  min-height: 300px;
}
.search .filter.toggleable-content.closed .button-filter,
.search .filter.toggleable-content.closed .filter-title,
.search .filter.toggleable-content.closed .filter-content {
  display: none;
}
.search .filter.toggleable-content.closed .button-toggle {
  margin: 0 auto;
}
.search .filter-list {
  padding: 16px 0;
}
.search .filter-list-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}
.search .filter-list-item .select {
  display: inline-block;
  margin-left: auto;
}
.search-results {
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
}
.search-results-start-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.search-results-start-image {
  width: 41px;
  height: 41px;
  margin-bottom: 28px;
}
.search-results-title {
  padding-bottom: 16px;
  margin-right: 16px;
  border-bottom: 1px solid #e2e3f4;
}
.search-results-cards {
  flex: 1;
  max-height: calc(90vh - 180px);
  padding: 16px 16px 12px 6px;
  overflow-y: auto;
}
.search-results-cards .spinner {
  margin: 0 auto;
}
.search-results-card {
  display: block;
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: border-color 0.8s ease;
}
.search-results-card:last-child {
  margin-bottom: 0;
}
.search-results-card:hover, .search-results-card:focus {
  border-color: #4667ff;
}
.search-results-card:focus-visible {
  outline: none;
}
.search-results-card-text {
  color: inherit;
  margin-bottom: 24px;
}
.search-results-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.search-results-card-tag {
  font-size: 12px;
  line-height: 20px;
}
.search-results-card strong {
  font-weight: 700;
}
.search-results-card-breadcrumbs {
  cursor: default;
  font-size: 12px;
  color: rgb(116, 141, 255);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.search-results-card-breadcrumbs .breadcrumbs-ellipsis {
  cursor: pointer;
  color: #4667ff;
  transition: all 0.35s ease;
}
.search-results-card-breadcrumbs .breadcrumbs-ellipsis:hover {
  color: #1e44f1;
}
.search-results-card-breadcrumbs .breadcrumbs-item {
  color: inherit;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
}
.search-results-card-breadcrumbs .breadcrumbs-separator {
  margin: 0 4px;
  color: rgb(116, 141, 255);
  user-select: none;
}
.search-results-card-breadcrumbs .breadcrumbs-tooltip {
  opacity: 1;
  position: absolute;
  transform: translateX(-50%);
  background: #ffffff;
  color: #090a0a;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  white-space: nowrap;
  box-shadow: 0 8px 24px 0 rgba(27, 27, 45, 0.12);
  z-index: 10;
  text-align: left;
  word-break: break-all;
  display: block;
  animation: all 0.18s cubic-bezier(0.4, 0, 0.2, 1);
}
.search-dropdown-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e2e3f4;
  background: #f0f2f9;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
}
.search-dropdown-footer.closed {
  display: none;
}
.search-dropdown-footer .search-contact a {
  color: #4667ff;
  text-decoration: underline;
}
.search-dropdown-footer .search-info {
  display: none;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
@media (min-width: 1024px) {
  .search-dropdown-footer .search-info {
    display: flex;
  }
}
.search-dropdown-footer .search-escape {
  margin-left: 18px;
  font-weight: 700;
  font-size: 10px;
  line-height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_variables.scss","webpack://./public/assets/vue/components/Search/SearchComponent.scss","webpack://./src/assets/scss/_mixins.scss"],"names":[],"mappings":"AA4EA;EACE;IACE,UAAA;IACA,4CAAA;EC3EF;ED6EA;IACE,UAAA;IACA,yCAAA;EC3EF;AACF;AAFA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAIF;;AAFA;ECbE,aAAA;EACA,uBAAA;EACA,mBAAA;EDcA,OAAA;AAMF;AALE;EAJF;IAKI,kBAAA;EAQF;AACF;AANE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,0BDwCwB;ECvCxB,mBD3BU;EC4BV,gCDGW;ACKf;AAPI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AASN;AANI;EACE,aAAA;AAQN;AALI;EACE,aAAA;AAON;AAHE;;EAEE,WAAA;EACA,YAAA;ECjDF,aAAA;EACA,uBAAA;EACA,mBAAA;ADuDF;AAJE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;AAMJ;AAJI;EACE,eD/CY;ACqDlB;AAHI;EACE,aAAA;AAKN;AADE;EACE,iBAAA;EACA,kBAAA;EACA,mBDtEU;ECuEV,yBDxCW;AC2Cf;AAFI;EALF;IAMI,aAAA;EAKJ;AACF;AAFE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAIJ;AAHI;EACE,aAAA;AAKN;AAJM;EAFF;IAGI,aAAA;EAON;AACF;AALI;EAXF;IAYI,cAAA;IACA,UAAA;EAQJ;AACF;AALE;EACE,YAAA;EACA,kBAAA;AAOJ;AALI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AAON;AANM;EANF;IAOI,UAAA;EASN;AACF;AALE;EACE,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,mBDnHU;ECoHV,gBAAA;EACA,yBDtFW;ECuFX,kBAAA;EACA,sBAAA;EAEA,WAAA;AAMJ;AAJI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SDlEU;ECmEV,YAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;AAMN;AALM;EAXF;IAYI,SAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;EAQN;AACF;AAHI;EADF;IAEI,aAAA;EAMJ;AACF;AAJI;EACE,kBAAA;EACA,gCDvHS;AC6Hf;AAHI;EACE,kBAAA;EACA,aAAA;AAKN;AAJM;EACE,yBD9HO;ACoIf;AALQ;EAGE,qBD7JG;ACkKb;AAFM;EACE,cAAA;AAIR;AADM;EACE,mBAAA;AAGR;AACI;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,6BDlJS;ECmJT,eAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,mBDtLQ;ACuLd;AAAM;EACE,OAAA;EACA,aAAA;EACA,yBD3JO;EC4JP,kBAAA;AAER;AAAQ;EAEE,qBD3LG;AC4Lb;AAKE;EACE,aAAA;EAEA,oBAAA;EACA,OAAA;AAJJ;AAMI;EACE,aAAA;AAJN;AAQE;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AANJ;AAOI;EANF;IAOI,aAAA;IACA,+BDzLS;ECqLb;AACF;AAMI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAJN;AAMM;EACE,iBAAA;EACA,yBDnMO;ECoMP,0BDjKoB;AC6J5B;AAKQ;EACE,oCDhOM;ECiON,yBAAA;AAHV;AAOM;EACE,YAAA;AALR;AASI;EACE,gBAAA;EACA,kBAAA;EACA,8BAhPe;EAiPf,mBAAA;AAPN;AAQM;EACE,cAAA;EACA,oBAAA;EACA,gCDxNO;ACkNf;AAQQ;EACE,mBAAA;AANV;AAWQ;EACE,aAAA;AATV;AAWU;EACE,aAAA;AATZ;AAcM;EACE,iBAAA;AAZR;AAeM;EACE,SAAA;EACA,gBAAA;AAbR;AAeQ;EACE,0BD/MkB;ECgNlB,yBAAA;AAbV;AAiBM;EACE,aAAA;AAfR;AAkBM;EACE,iBAAA;EACA,yBD7PO;AC6Of;AAkBM;EACE,WAAA;EACA,eAAA;AAhBR;AAiBQ;EACE,iBAAA;AAfV;AAmBQ;EACE,SAAA;AAjBV;AAmBU;EACE,UAAA;EACA,mBAAA;AAjBZ;AAsBU;EAEE,yBAAA;AArBZ;AAyBQ;EACE,iBAAA;EACA,cDpTG;ECqTH,gBAAA;AAvBV;AA0BQ;EACE,kBAAA;AAxBV;AA0BU;EACE,UAAA;AAxBZ;AA4BQ;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AA1BV;AA+BQ;EACE,aAAA;AA7BV;AAgCQ;EACE,aAAA;AA9BV;AAiCQ;EACE,aAAA;AA/BV;AAkCQ;EACE,uBAAA;AAhCV;AAoCI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,0BD/RsB;AC6P5B;AAoCM;EANF;IAOI,aAAA;EAjCN;AACF;AAkCM;EACE,iBAAA;EACA,iBAAA;AAhCR;AAiCQ;;;EAGE,aAAA;AA/BV;AAkCQ;EACE,cAAA;AAhCV;AAsCE;EACE,eAAA;AApCJ;AAqCI;ECpXF,aAAA;EACA,mBAAA;EDqXI,cAAA;AAlCN;AAoCM;EACE,qBAAA;EACA,iBAAA;AAlCR;AAuCE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AArCJ;AAuCI;EC3YF,aAAA;EACA,uBAAA;EACA,mBAAA;ED2YI,sBAAA;EACA,WAAA;EACA,YAAA;AAnCN;AAsCI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AApCN;AAuCI;EACE,oBAAA;EACA,kBAAA;EACA,gCD1XS;ACqVf;AAwCI;EACE,OAAA;EACA,8BA7ZiB;EA8ZjB,2BAAA;EACA,gBAAA;AAtCN;AAuCM;EACE,cAAA;AArCR;AAyCI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kCAAA;AAvCN;AAyCM;EACE,gBAAA;AAvCR;AA0CM;EAEE,qBDhbK;ACuYb;AA2CM;EACE,aAAA;AAzCR;AA2CM;EACE,cAAA;EACA,mBAAA;AAzCR;AA4CM;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA1CR;AA6CM;EACE,eAAA;EACA,iBAAA;AA3CR;AA6CM;EACE,gBAAA;AA3CR;AA6CM;EACE,eAAA;EACA,eAAA;EACA,yBDzbqB;EC0brB,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA3CR;AA6CQ;EACE,eAAA;EACA,cDldG;ECmdH,0BDrZkB;AC0W5B;AA4CU;EACE,cDldO;ACwanB;AA6CQ;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AA3CV;AA6CQ;EACE,aAAA;EACA,yBD/cmB;ECgdnB,iBAAA;AA3CV;AA6CQ;EACE,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBD3eI;EC4eJ,cDjdC;ECkdD,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,+CD3ayB;EC4azB,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,iDDnbwB;ACwYlC;AAiDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,6BDpeW;ECqeX,mBDnfqB;ECofrB,8BAAA;EACA,+BAAA;AA/CJ;AAgDI;EACE,aAAA;AA9CN;AAkDM;EACE,cDzgBK;EC0gBL,0BAAA;AAhDR;AAoDI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAlDN;AAoDM;EANF;IAOI,aAAA;EAjDN;AACF;AAoDI;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAlDN","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
